import { useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSession } from '@/app/providers/session-provider';
import { useTenant } from '@/tenant/tenant-provider';
import { AssetIcon } from '@/shared/assets';
import PopUpInfos from '../../shared/components/PopUpInfos';

const DISPLAY_LABELS = { staff: 'Team', 'workspace-users': 'Utenti' };

export default function BottomNavigation() {
  const { navigation } = useTenant();
  const { canAccessRouteId } = useSession();
  const location = useLocation();
  const trackRef = useRef(null);
  const visibleNavigation = navigation.filter((item) => canAccessRouteId(item.routeId));

  useEffect(() => {
    const alignActiveItem = () => {
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      trackRef.current?.querySelector('[aria-current="page"]')?.scrollIntoView?.({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    };

    alignActiveItem();
    window.addEventListener('resize', alignActiveItem);
    return () => window.removeEventListener('resize', alignActiveItem);
  }, [location.pathname, visibleNavigation.length]);

  return (
    <nav className="app-bottom-nav" aria-label="Navigazione principale">
      <div className="app-bottom-nav__scroller">
        <div className="app-bottom-nav__track" ref={trackRef}>
          {visibleNavigation.map((item) => {
            const active =
              location.pathname === item.path ||
              (item.path !== '/' && location.pathname.startsWith(item.path + '/'));
            const label = DISPLAY_LABELS[item.routeId] || item.label;
            return (
              <PopUpInfos key={item.routeId} label={label}>
                <NavLink
                  to={item.path}
                  end={item.path === '/'}
                  aria-label={label}
                  className={`app-bottom-nav__link${active ? ' is-active' : ''}`}
                >
                  {({ isActive }) => (
                    <>
                      {item.iconKey ? (
                        <AssetIcon name={item.iconKey} className="app-bottom-nav__icon" size={32} />
                      ) : null}
                      {isActive ? <span className="app-bottom-nav__sr-only">Pagina corrente</span> : null}
                    </>
                  )}
                </NavLink>
              </PopUpInfos>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
